<div class="filter-form-container">
  @if (filtersLoading()) {
    <div class="skeleton-filters mobile-filters">
      <div class="skeleton-filter-select shimmer"><span>{{filterCategory.SPECIALTY}}</span></div>
      <div class="skeleton-more-filters shimmer">
        <span class="skeleton-icon-placeholder" aria-hidden="true"></span>
      </div>
    </div>
    <div class="skeleton-filters desktop-filters">
      <div class="skeleton-filter-select shimmer"><span>{{filterCategory.STATE}}</span></div>
      <div class="skeleton-filter-select shimmer"><span>{{filterCategory.THERAPY_OR_PSYCHIATRY}}</span></div>
      <div class="skeleton-filter-select shimmer"><span>{{filterCategory.INSURANCE}}</span></div>
      <div class="skeleton-filter-select shimmer"><span>{{filterCategory.SPECIALTY}}</span></div>
      <div class="skeleton-more-filters shimmer">
        <span class="skeleton-icon-placeholder" aria-hidden="true"></span>
      </div>
    </div>
  }
  @else {
    @if (isMobile()) {
      <form
        [formGroup]="filterFormGroup"
        class="mobile-filters"
      >
        <filter-select-mobile
          [filterFormGroup]="filterFormGroup"
          [placeholder]="filterCategory.SPECIALTY"
          [filterCategories]="mobileMainFilters"
        >
        </filter-select-mobile>

        <filter-select-mobile
          [filterFormGroup]="filterFormGroup"
          placeholder="More filters"
          [filterCategories]="mobileMoreFilters"
          icon="filter_list"
          data-test="more-filters-mobile"
        >
        </filter-select-mobile>
      </form>

      <provider-name-search
        [layout]="searchLayout.FULL_SCREEN"
        [internalDirectory]="internalDirectory()"
      ></provider-name-search>
    }
    @else {
      <form
        [formGroup]="filterFormGroup"
        class="desktop-filters"
        [class.hidden]="isSearchPanelOpen()"
      >
        <filter-select
          formControlName="state"
          [placeholder]="filterCategory.STATE"
          data-test="location"
          [categorizedOptions]="stateOptions"
          [isMulti]="false"
          [isSearchable]="true"
        >
        </filter-select>

        <filter-select
          formControlName="serviceType"
          [placeholder]="filterCategory.THERAPY_OR_PSYCHIATRY"
          data-test="therapy-or-psychiatry"
          [categorizedOptions]="serviceTypeOptions"
          [isMulti]="false"
          [isSearchable]="false"
          [size]="8"
        >
        </filter-select>

        <filter-select
          formControlName="insurance"
          [placeholder]="filterCategory.INSURANCE"
          data-test="insurance"
          [categorizedOptions]="insuranceOptions"
          [isMulti]="false"
          [isSearchable]="true"
          [size]="12"
        >
        </filter-select>

        <filter-select
          formControlName="specialties"
          [placeholder]="filterCategory.SPECIALTY"
          data-test="concerns"
          [categorizedOptions]="specialtyOptions"
          [isMulti]="true"
          [isSearchable]="true"
        >
        </filter-select>

        <more-filters
          [filterFormGroup]="filterFormGroup"
          [filterCategories]="desktopMoreFilters"
          data-test="more-filters-desktop"
        >
        </more-filters>
      </form>

      <provider-name-search
        class="desktop-search"
        [layout]="searchLayout.INLINE"
        [internalDirectory]="internalDirectory()"
        [dropdownRevealDelayMs]="150"
        (panelOpenChange)="isSearchPanelOpen.set($event)"
        [class.expanded]="isSearchPanelOpen()"
      ></provider-name-search>
    }
  }
</div>

